import {
	AUTENTICACAO_LOGAR,
	AUTENTICACAO_SAIR,
	SET_PIPEDRIVE_DEAL_ID,
	SET_ORCAMENTO_ID
} from "./actionTypes";

export const authLogin = loginData => ({
	type: AUTENTICACAO_LOGAR,
	userAuth: loginData.success,
	userName: loginData.name,
	userToken: loginData.token,
	userId: loginData.userId
});

export const authLogout = () => ({
	type: AUTENTICACAO_SAIR,
	userAuth: false,
	userName: "",
	userToken: "",
	userId: ""
});

export const pipedriveDealId = dealId => ({
	type: SET_PIPEDRIVE_DEAL_ID,
	pipedriveDealId: dealId
});

export const orcamentoId = _orcamentoId => ({
	type: SET_ORCAMENTO_ID,
	orcamentoId: _orcamentoId
});
